import React from 'react'
import PropTypes from 'prop-types'

const ProductTitle = ({ title, color }) => {
  return (
    <div className="py-12">
      <div className="flex">
        <div>
          <h1 className="text-3xl lg:text-5xl 2xl:text-6xl uppercase tracking-tight leading-none">
            {title}
          </h1>
          {color && (
            <div className="text-xs lg:text-sm text-right uppercase leading-none">
              {color}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

ProductTitle.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
}

export default ProductTitle
